import { identity } from 'lodash';
import { handleAggregatorResponse } from '../../services/aggregator';
import createAction from '../../services/create-action';
export const FETCH_TAGS_REQUEST = 'tags/FETCH_REQUEST';
export const FETCH_TAGS_SUCCESS = 'tags/FETCH_SUCCESS';
export const FETCH_TAGS_FAILURE = 'tags/FETCH_FAILURE';
export const fetchTagsRequest = createAction(FETCH_TAGS_REQUEST);
export const fetchTagsSuccess = createAction(FETCH_TAGS_SUCCESS, (payload, meta) => payload, (payload, meta) => meta);
export const fetchTagsFailure = createAction(FETCH_TAGS_FAILURE);
const fetchTagsAction = ({ onlyWithPublishedPosts = false, labelStarts, limit = 500, mostPopular = false, language, } = {}) => (dispatch, _getState, { request }) => {
    const multipleFilters = [onlyWithPublishedPosts, labelStarts, language].filter(identity).length >
        1;
    const filter = multipleFilters
        ? {
            $and: [
                onlyWithPublishedPosts && { publicationCount: { $gt: 0 } },
                labelStarts && { label: { $startsWith: labelStarts } },
                language && { language: { $eq: language } },
            ].filter(identity),
        }
        : Object.assign(Object.assign(Object.assign({}, (onlyWithPublishedPosts && { publicationCount: { $gt: 0 } })), (labelStarts && { label: { $startsWith: labelStarts } })), (language && { language: { $eq: language } }));
    return request.post('/v2/tags/query', Object.assign({ filter, paging: {
            offset: 0,
            limit,
        } }, (mostPopular && {
        sort: [{ fieldName: 'publicationCount', order: 'DESC' }],
    })), {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
const createFetchTags = (action) => (args = {}) => (dispatch) => {
    dispatch(fetchTagsRequest());
    return dispatch(action(args))
        .then(({ tags }) => dispatch(fetchTagsSuccess(tags, Boolean(args.mostPopular))))
        .catch(() => dispatch(fetchTagsFailure()));
};
export const fetchTags = createFetchTags(fetchTagsAction);
export const handleTagsResponse = createFetchTags(handleAggregatorResponse);
export default fetchTags;
//# sourceMappingURL=fetch-tags.js.map